"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6007],{

/***/ 56007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ common_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider_Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Snackbar/Snackbar.js + 3 modules
var Snackbar = __webpack_require__(17155);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./utils/hooks/index.js
var hooks = __webpack_require__(13946);
// EXTERNAL MODULE: ./store/selfConstruct/selfConstructSlice.js
var selfConstructSlice = __webpack_require__(67030);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/TitleWithRemark/index.js
var common_TitleWithRemark = __webpack_require__(82287);
;// CONCATENATED MODULE: ./utils/clean-url.js
/**
 * 用於清理字串中的不可見字符和標準化 URL
 */ /**
 * 正則表達式匹配各種不可見字符：
 * - \p{Cf}: Unicode 格式控制字符，包括：
 *   - 200B: 零寬空格 (Zero Width Space)
 *   - 200C: 零寬非連接符 (Zero Width Non-Joiner)
 *   - 200D: 零寬連接符 (Zero Width Joiner)
 *   - 2060: 單詞連接符 (Word Joiner)
 *   - FEFF: 零寬非斷空格，也稱為位元順序標記 (BOM)
 * - \u00A0: 不間斷空格 (Non-Breaking Space)
 *
 * 這些字符通常肉眼不可見，但可能會導致 URL 失效或比較不一致
 */ const INVISIBLES = RegExp("[\\p{Cf}\\u00A0]", "gu") // Cf 含 200B/200C/200D/2060/FEFF；
;
const clean = (s)=>typeof s === "string" ? s.normalize("NFC").replace(INVISIBLES, "").trim() : s;

// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
;// CONCATENATED MODULE: ./components/common/Footer/LinkItem.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const LinkWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(_templateObject(), (param)=>{
    let { theme , $isFirst  } = param;
    return "\n  margin-top: ".concat($isFirst ? 0 : theme.spacing(3), ";\n\n  & > a,\n  & > span {\n    color: ").concat(theme.palette.text.minus2, ";\n  }\n");
});
const LinkItem_LinkItem = (param)=>{
    let { href , children , $isFirst , onClick , ...rest } = param;
    const cleanedHref = clean(href);
    // 有 href：渲染真正的 next/link 連結，行為不變
    if (cleanedHref) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
            $isFirst: $isFirst,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                href: cleanedHref,
                $origin: true,
                ...rest,
                onClick: onClick,
                children: children
            })
        });
    }
    // 無 href：渲染非 anchor 的 <span>（不帶 href），避免 hover 時瀏覽器狀態列
    // 浮現由 next/link 空字串 href 相對當前 route 解析出的網址。
    const { style  } = rest;
    const isClickable = !!onClick;
    // 因 Link 改為 span，故考量 a11y
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onClick(event);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
        $isFirst: $isFirst,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            component: "span",
            role: isClickable ? "button" : undefined,
            tabIndex: isClickable ? 0 : undefined,
            onClick: onClick,
            onKeyDown: isClickable ? handleKeyDown : undefined,
            style: {
                cursor: isClickable ? "pointer" : "default",
                ...style
            },
            children: children
        })
    });
};
/* harmony default export */ var Footer_LinkItem = (LinkItem_LinkItem);

;// CONCATENATED MODULE: ./components/common/Footer/MobileServiceItem.js






const MobileServiceItem = (param)=>{
    let { selfConstruct  } = param;
    const { data: classifications  } = useServiceClassifications({
        displayVisible: selfConstruct.active ? "all" : "visible"
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ _jsx(TitleWithRemark, {
                    variant: "subtitle1",
                    my: 4,
                    children: "熱門服務"
                }),
                /*#__PURE__*/ _jsx(Divider, {}),
                /*#__PURE__*/ _jsx(Box, {
                    my: 7.5,
                    children: classifications && classifications.map((data, idx)=>{
                        /*#__PURE__*/ return _jsx(LinkItem, {
                            href: "/vender?serviceItem=".concat(data === null || data === void 0 ? void 0 : data._id),
                            $isFirst: idx === 0,
                            children: data.name
                        }, idx);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_MobileServiceItem = ((/* unused pure expression or super */ null && (MobileServiceItem)));

// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
;// CONCATENATED MODULE: ./components/common/Footer/HelfSplitGrid.js

function HelfSplitGrid_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    HelfSplitGrid_templateObject = function() {
        return data;
    };
    return data;
}


const HelfSplitGrid_HelfSplitGrid = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(HelfSplitGrid_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    display: grid;\n    grid-auto-rows: auto;\n\n    grid-template-columns: repeat(2, 1fr);\n\n    grid-column-gap: ".concat(theme.spacing(2), ";\n    ").concat(theme.breakpoints.up("lg"), " {\n      grid-column-gap: ").concat(theme.spacing(6), ";\n    }\n  ");
});
/* harmony default export */ var Footer_HelfSplitGrid = (HelfSplitGrid_HelfSplitGrid);

;// CONCATENATED MODULE: ./components/common/Footer/DesktopServiceItem.js










const DesktopServiceItem = (param)=>{
    let { selfConstruct , onSyServiceClick  } = param;
    const { houseCleaningData , deviceCleaningData , relocationData , decorationData  } = useAllServiceClassificationsByCategory(selfConstruct === null || selfConstruct === void 0 ? void 0 : selfConstruct.active);
    return /*#__PURE__*/ _jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ _jsxs(TitleWithRemark, {
                variant: "subtitle1",
                my: 4,
                children: [
                    /*#__PURE__*/ _jsx(HideInMobileBox, {
                        component: "span",
                        children: "熱門"
                    }),
                    "服務"
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsxs(HelfSplitGrid, {
                children: [
                    /*#__PURE__*/ _jsxs(Box, {
                        my: 7.5,
                        children: [
                            houseCleaningData.map((data, idx)=>{
                                /*#__PURE__*/ return _jsx(LinkItem, {
                                    href: "/vender?serviceItem=".concat(data === null || data === void 0 ? void 0 : data._id),
                                    $isFirst: idx === 0,
                                    children: data.name
                                }, "house-clean-".concat(idx));
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                color: "text.minus2",
                                my: 5,
                                children: "-"
                            }),
                            relocationData.map((data, idx)=>{
                                /*#__PURE__*/ return _jsx(LinkItem, {
                                    href: "/vender?serviceItem=".concat(data === null || data === void 0 ? void 0 : data._id),
                                    $isFirst: idx === 0,
                                    children: data.name
                                }, "relocation-".concat(idx));
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        my: 7.5,
                        children: [
                            deviceCleaningData.map((data, idx)=>{
                                /*#__PURE__*/ return _jsx(LinkItem, {
                                    href: "/vender?serviceItem=".concat(data === null || data === void 0 ? void 0 : data._id),
                                    $isFirst: idx === 0,
                                    children: data.name
                                }, "device-clean-".concat(idx));
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                color: "text.minus2",
                                my: 5,
                                children: "-"
                            }),
                            decorationData.map((data, idx)=>{
                                /*#__PURE__*/ return _jsx(LinkItem, {
                                    href: "/vender?serviceItem=".concat(data === null || data === void 0 ? void 0 : data._id),
                                    onClick: onSyServiceClick,
                                    $isFirst: idx === 0,
                                    children: data.name
                                }, "decoration-".concat(idx));
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_DesktopServiceItem = ((/* unused pure expression or super */ null && (DesktopServiceItem)));

;// CONCATENATED MODULE: ./components/common/Footer/FooterLinks.js






const FooterLinks = (param)=>{
    let { title , links , bottomComponent  } = param;
    const isLgUp = (0,useMediaQuery/* default */.Z)((theme)=>theme.breakpoints.up("lg"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TitleWithRemark/* default */.Z, {
                variant: "labelLarge",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                py: isLgUp ? 5 : 4,
                children: !isLgUp ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    sx: {
                        rowGap: "12px"
                    },
                    children: [
                        links.map((link, index, array)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LinkItem, {
                                        href: link.href,
                                        originalLink: link.originalLink,
                                        target: link.target,
                                        $isFirst: true,
                                        children: link.text
                                    }),
                                    index < array.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        component: "span",
                                        mx: 3,
                                        height: "17px",
                                        width: "1px",
                                        backgroundColor: "#D4D4D4"
                                    })
                                ]
                            }, index)),
                        bottomComponent
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        links.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LinkItem, {
                                href: link.href,
                                originalLink: link.originalLink,
                                target: link.target,
                                $isFirst: index === 0,
                                children: link.text
                            }, index)),
                        bottomComponent
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Footer_FooterLinks = (FooterLinks);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
;// CONCATENATED MODULE: ./components/common/Footer/AppDownload.js

function AppDownload_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    AppDownload_templateObject = function() {
        return data;
    };
    return data;
}







const LinkImg = emotion_styled_browser_esm/* default.img */.Z.img(AppDownload_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    height: 40px;\n    width: 120px;\n    ".concat(theme.breakpoints.up("xl"), " {\n      width: 100%;\n    }\n  ");
});
const AppDownload = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileGrid */.W, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        display: "flex",
                        justifyContent: {
                            xs: "left",
                            xl: "center"
                        },
                        mb: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/app_qrcode_new.svg",
                            width: 120,
                            height: 120,
                            alt: ""
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    xl: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LinkItem, {
                        $isFirst: true,
                        href: "https://apps.apple.com/tw/app/信義居家-清潔-搬家-裝潢-修繕服務/id1581712189",
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkImg, {
                            src: "/img/app_store.svg",
                            alt: ""
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    xl: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LinkItem, {
                        $isFirst: true,
                        href: "https://play.google.com/store/apps/details?id=com.sinyi.living",
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkImg, {
                            src: "/img/google_play.svg",
                            alt: ""
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_AppDownload = (AppDownload);

;// CONCATENATED MODULE: ./components/common/Footer/SocialMediaBlock.js

function SocialMediaBlock_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SocialMediaBlock_templateObject = function() {
        return data;
    };
    return data;
}







const StyleHelfSplitGrid = (0,emotion_styled_browser_esm/* default */.Z)(Footer_HelfSplitGrid)(SocialMediaBlock_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    grid-template-columns: 1fr;\n    grid-row-gap: ".concat(theme.spacing(4), ";\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      grid-template-columns: repeat(2, 1fr);\n      grid-row-gap: 0;\n    }\n  ");
});
const SocialMediaBlock = (param)=>{
    let { title , socialLinks  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_TitleWithRemark/* default */.Z, {
                    variant: "labelLarge",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleHelfSplitGrid, {
                py: {
                    xs: 4,
                    lg: 5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        display: "flex",
                        gap: {
                            xs: 3,
                            lg: 4
                        },
                        children: socialLinks.map((social, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: social.href || "",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                style: {
                                    cursor: "pointer"
                                },
                                children: social.icon
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_AppDownload, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_SocialMediaBlock = (SocialMediaBlock);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
;// CONCATENATED MODULE: ./utils/api/general/getSinyiSiteResources.js

const getSinyiSiteResources = ()=>{
    const url = "https://www2.sinyi.com.tw/footer/footer_sinyiother.json";
    return (0,request/* safeAwait */.Ev)(fetch(url).then((response)=>response.json()));
};

;// CONCATENATED MODULE: ./components/common/Footer/SinyiResources.js











const defaultSinyiResources = [
    {
        subtitle: "信義房屋粉絲團",
        url: "https://www.facebook.com/sinyifans/"
    },
    {
        subtitle: "信義房屋YouTube",
        url: "https://www.youtube.com/channel/UCU76s7FGtDvDta2mf2Zdn4Q"
    },
    {
        subtitle: "信義房屋Android APP",
        url: "https://play.google.com/store/apps/details?id=com.thinkermobile.sinyi&hl=zh_TW"
    },
    {
        subtitle: "信義房屋Ios APP",
        url: "https://apps.apple.com/tw/app/%E4%BF%A1%E7%BE%A9%E6%88%BF%E5%B1%8B-%E9%97%9C%E6%96%BC%E5%AE%B6-%E6%89%BE%E4%BF%A1%E7%BE%A9%E8%81%8A%E8%81%8A/id362879359"
    },
    {
        subtitle: "信義房屋Wiki",
        url: "https://zh.wikipedia.org/zh-tw/%E4%BF%A1%E7%BE%A9%E6%88%BF%E5%B1%8B"
    },
    {
        subtitle: "信義房屋房市新聞",
        url: "https://www.sinyinews.com.tw/"
    }
];
const SinyiResources = ()=>{
    const [sinyiResources, setSinyiResources] = (0,react.useState)(defaultSinyiResources);
    const [modal, setModal] = (0,react.useState)({
        open: false
    });
    const isLgUp = (0,useMediaQuery/* default */.Z)((theme)=>theme.breakpoints.up("lg"));
    const openSinyiResourceModal = async ()=>{
        const [resources, error] = await getSinyiSiteResources();
        if (!error) {
            var _resources_brands_map, _resources_brands;
            const links = (_resources_brands_map = resources === null || resources === void 0 ? void 0 : (_resources_brands = resources.brands) === null || _resources_brands === void 0 ? void 0 : _resources_brands.map((brand)=>brand.content)) === null || _resources_brands_map === void 0 ? void 0 : _resources_brands_map.reduce((results, content)=>results.concat(content), []);
            // 由於網站資源連結不是由我們維護，故在以下添加要新增的項目
            // 添加信義開發連結
            if (links && Array.isArray(links)) {
                links.push({
                    subtitle: "信義開發",
                    url: "https://www.xinyikf.com.tw/"
                });
            }
            setSinyiResources(links);
        }
        setModal({
            open: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            !isLgUp ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        component: "span",
                        mx: 3,
                        height: "17px",
                        width: "1px",
                        backgroundColor: "#D4D4D4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LinkItem, {
                        $isFirst: isLgUp ? false : true,
                        onClick: openSinyiResourceModal,
                        style: {
                            cursor: "pointer"
                        },
                        children: "信義資源網站"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LinkItem, {
                $isFirst: isLgUp ? false : true,
                onClick: openSinyiResourceModal,
                style: {
                    cursor: "pointer"
                },
                children: "信義資源網站"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* InfoModal */.nv, {
                open: modal.open,
                onClose: ()=>setModal({
                        open: false
                    }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                flexGrow: 1,
                                pl: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitle2",
                                    children: "信義資源網站"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                py: 2,
                                pr: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: ()=>setModal({
                                            open: false
                                        }),
                                    size: "large",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        p: 5,
                        pt: 1,
                        pb: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            children: sinyiResources === null || sinyiResources === void 0 ? void 0 : sinyiResources.map((resource, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_LinkItem, {
                                        href: resource.url,
                                        target: "_blank",
                                        children: resource.subtitle
                                    })
                                }, index))
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_SinyiResources = (SinyiResources);

// EXTERNAL MODULE: ./config/theme.js + 1 modules
var config_theme = __webpack_require__(26059);
// EXTERNAL MODULE: ./components/common/SVGElements/FacebookIcon.js
var FacebookIcon = __webpack_require__(47624);
// EXTERNAL MODULE: ./components/common/SVGElements/LineCircle.js
var LineCircle = __webpack_require__(52915);
// EXTERNAL MODULE: ./components/common/SVGElements/SVG.js
var SVG = __webpack_require__(54806);
;// CONCATENATED MODULE: ./components/common/SVGElements/YoutubeIcon.js


const YoutubeIconSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SVG/* default */.Z, {
        width: "25",
        height: "18",
        viewBox: "0 0 25 18",
        fill: "none",
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.60941 0.880104C7.94386 0.693661 10.6989 0.600006 12.8 0.600006C14.9012 0.600006 17.6094 0.693661 19.9907 0.880104C22.7457 1.11424 24.1471 1.58078 24.52 4.33581C24.7064 5.59668 24.8 7.3241 24.8 9.09834C24.8 10.8726 24.7064 12.6468 24.52 13.8609C24.1471 16.6627 22.7457 17.0833 19.9907 17.3166C17.6094 17.5499 14.9012 17.5967 12.8 17.5967C10.6989 17.5967 7.94386 17.5499 5.60941 17.3166C2.85439 17.0833 1.40707 16.6627 1.03332 13.8609C0.892837 12.6468 0.800049 10.8726 0.800049 9.09834C0.800049 7.3241 0.892837 5.59668 1.03332 4.33581C1.40707 1.58078 2.85439 1.11424 5.60941 0.880104Z",
                fill: "#FF0000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.3719 5.50293L16.6286 9.09825L10.3719 12.7413V5.50293Z",
                fill: "white"
            })
        ]
    });
};

// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
;// CONCATENATED MODULE: ./components/common/Footer/FooterData.js



// 文章圖輯區塊連結
const ARTICLE_ALBUM_LINKS = [
    {
        href: "/album",
        text: "靈感圖輯"
    },
    {
        href: "/article",
        text: "知識文章"
    },
    {
        href: "https://livinglife.com.tw/events/edm-subscription/ ",
        text: "訂閱電子報",
        originalLink: true,
        target: "_blank"
    }
];
// 關於信義居家連結
const ABOUT_SINYI_LINKS = [
    {
        href: "https://livinglife.com.tw/",
        text: "信義居家官網",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://livinglife.com.tw/events/english-service/",
        text: "English Service",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://livinglife.com.tw/mkt/join-livinglife",
        text: "信義居家廠商募集",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://link.livinglife.com.tw/fVJi6s",
        text: "常見問與答",
        originalLink: true,
        target: "_blank"
    },
    {
        href: constants/* LS_TERMS_OF_SERVICE_LINK */.TI,
        text: "服務條款",
        originalLink: true,
        target: "_blank"
    },
    {
        href: constants/* LS_PRIVACY_POLICY_LINK */.zr,
        text: "隱私權政策",
        originalLink: true,
        target: "_blank"
    },
    {
        text: "ISO9001 服務品質管理認證"
    }
];
// 信義集團連結
const SINYI_GROUP_LINKS = [
    {
        href: "https://www.sinyi.com.tw/",
        text: "信義房屋官網",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://www.sinyi.com.tw/?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer",
        text: "買屋",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://www.sinyi.com.tw/sell/mytrade?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer",
        text: "賣屋",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://www.sinyi.com.tw/rent/index.php?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer",
        text: "租屋",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://www.sinyi.com.tw/tradeinfo/list?utm_source=livinglife&utm_medium=livinglife&utm_campaign=livinglife_footer",
        text: "實價登錄",
        originalLink: true,
        target: "_blank"
    },
    {
        href: "https://www.localbond.tw/",
        text: "社區幫官網",
        originalLink: true,
        target: "_blank"
    }
];
// 社群媒體連結
const SOCIAL_MEDIA_LINKS = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookIcon/* FacebookIconSVG */.x, {
            $color: "blue.main",
            width: "24px",
            height: "24px"
        }),
        href: "https://www.facebook.com/livingsinyi"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineCircle/* LineCircleSVG */.L, {
            width: "24px",
            height: "24px"
        }),
        href: "https://lin.ee/ekCuLPO"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubeIconSVG, {
            width: "24px",
            height: "24px"
        }),
        href: "https://www.youtube.com/@sinyi_living"
    }
];

;// CONCATENATED MODULE: ./components/common/Footer/index.js

function Footer_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Footer_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}




















const FooterWrap = (0,emotion_styled_browser_esm/* default */.Z)(Box_Box/* default */.Z)(Footer_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    background-color: ".concat(theme.palette.background.gray, ";\n    padding: ").concat(theme.spacing(10), " 0;\n  ");
});
const GridLayout = (0,emotion_styled_browser_esm/* default */.Z)(ContentWrapper/* MaxWidthWrapper */.x)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    display: grid;\n    grid-auto-rows: auto;\n    max-width: ".concat(config_theme/* indexPageMaxContentWidth */.LN, ";\n\n    grid-template-columns: 1fr;\n    grid-row-gap: ").concat(theme.spacing(4), ";\n\n    padding-left: ").concat(theme.spacing(4), ";\n    padding-right: ").concat(theme.spacing(4), ";\n\n    ").concat(theme.breakpoints.up("md"), " {\n      padding-left: ").concat(theme.spacing(8), ";\n      padding-right: ").concat(theme.spacing(8), ";\n    }\n\n    ").concat(theme.breakpoints.up("lg"), " {\n      grid-template-columns: repeat(5, 1fr);\n      grid-column-gap: ").concat(theme.spacing(6), ";\n      grid-row-gap: 0;\n    }\n\n    ").concat(theme.breakpoints.up("xl"), " {\n      padding-left: ").concat(theme.spacing(12), ";\n      padding-right: ").concat(theme.spacing(12), ";\n    }\n  ");
});
const SinyiTrackGridItem = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    grid-column: 1;\n    ".concat(theme.breakpoints.up("lg"), " {\n      grid-column: 4 / 6;\n    }\n  ");
});
const Footer = (param)=>{
    let { ...rest } = param;
    const theme = (0,useTheme/* default */.Z)();
    const isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    const selfConstruct = (0,es/* useSelector */.v9)(selfConstructSlice/* selectSelfConstruct */.k$);
    const currentYear = (0,hooks/* useGetYearForFooter */.cB)();
    const [toast, setToast] = (0,react.useState)({
        open: false,
        message: ""
    });
    const [isCsr, setCsr] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        // We hope footer re-render according to isMobile while client side is ready
        setCsr(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrap, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GridLayout, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterLinks, {
                        title: "文章圖輯",
                        links: ARTICLE_ALBUM_LINKS
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterLinks, {
                        title: "關於信義居家",
                        links: ABOUT_SINYI_LINKS
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterLinks, {
                        title: "信義集團",
                        links: SINYI_GROUP_LINKS,
                        bottomComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_SinyiResources, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SinyiTrackGridItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_SocialMediaBlock, {
                            title: "追蹤信義居家",
                            socialLinks: SOCIAL_MEDIA_LINKS
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                my: 6,
                maxWidth: config_theme/* indexPageMaxContentWidth */.LN,
                mx: "auto",
                px: {
                    xs: 4,
                    md: 8,
                    xl: 12
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_Divider/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "flex-start" : "center",
                maxWidth: config_theme/* indexPageMaxContentWidth */.LN,
                margin: "0 auto",
                px: {
                    xs: 4,
                    md: 8,
                    xl: 12
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                        order: isMobile ? 2 : 1,
                        alignSelf: isMobile ? "center" : "auto",
                        mt: isMobile ? 10 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/img/logo_with_text.svg",
                            width: 148,
                            height: 54,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        color: "text.minus2",
                        order: isMobile ? 1 : 2,
                        ml: isMobile ? 0 : 7.5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "span",
                                children: "服務專線 (02)2722-3589"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "span",
                                mt: 2,
                                children: "服務時間 週一～五 9:00-12:00、13:30-18:00"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "span",
                                mt: 2,
                                children: "客服信箱 living@sinyi.com.tw"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        color: "text.secondary",
                        alignSelf: isMobile ? "center" : "auto",
                        alignItems: isMobile ? "center" : "flex-end",
                        mt: isMobile ? 4 : 0,
                        flex: isMobile ? 0 : 1,
                        order: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "span",
                                children: "110 台北市信義區信義路五段100號"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                component: "span",
                                mt: 2,
                                children: "\xa9 ".concat(currentYear, " 信義房屋股份有限公司 版權所有")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
                open: toast.open,
                autoHideDuration: 6000,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                message: toast.message,
                onClose: ()=>setToast({
                        open: false,
                        message: ""
                    })
            })
        ]
    });
};
/* harmony default export */ var common_Footer = (Footer);


/***/ }),

/***/ 82287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29630);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);




/**
 * 標題與提醒元件
 * @param {*} children - 標題，當有 'children' 與 'title' 同時存在，'children' 優先採用
 * @param {*} title - 標題
 * @param {string} [variant='h5'] - 標題文字大小（Default 'h5'）
 * @param {*} [remark] - 提醒（Optional）
 */ const TitleWithRemark = (param)=>/*#__PURE__*/ {
    let { children , title , remark , variant ="h5" , color , titleId , remarkId , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        ...rest,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: variant,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    mr: 1,
                    fontWeight: "fontWeightBold",
                    color: color,
                    id: titleId,
                    children: children ? children : title
                })
            }),
            remark && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                component: "span",
                variant: "subtitle1",
                color: "textSecondary",
                id: remarkId,
                children: remark
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TitleWithRemark);


/***/ })

}]);